// extracted by mini-css-extract-plugin
export default {"star-icon":"_s24paa","starIcon":"_s24paa","rating":"_1brd01b"};